import styled from 'styled-components';

interface StyledRichTextProps {
  $fontColor?: string;
  $fontHeadingFamily?: string;
  $fontHeadingSize?: number;
  $fontBodyFamily?: string;
  $fontBodySize?: number;
  $buttonLinksColor?: string;
}

export const StyledThemeRichText = styled.div<StyledRichTextProps>`
  color: ${({ $fontColor }) => $fontColor || 'inherit'};
  line-height: ${({ theme }) => theme.typography.generateLineHeight(theme.typography.generateFontSize(2), 'lg')}px;
  overflow-wrap: anywhere;
  font-family: ${({ $fontBodyFamily }) => $fontBodyFamily || 'inherit'};

  p {
    font-size: ${({ $fontBodySize }) => `${$fontBodySize}px` || 'inherit'};
  }

  H1,
  H2,
  H3,
  H4,
  H5,
  H6 {
    font-family: ${({ $fontHeadingFamily }) => $fontHeadingFamily || 'inherit'};
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a.community-mention {
    text-decoration: none;
    pointer-events: none;
    &:link,
    &:hover,
    &:active,
    &:visited {
      color: ${({ $fontColor }) => $fontColor || 'inherit'};
    }
  }

  a {
    &:link,
    &:visited {
      color: ${({ $buttonLinksColor }) => $buttonLinksColor || 'inherit'};
    }
  }

  td,
  th {
    padding: 5px 10px;
  }
`;
